var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { isSearchedProject } from 'api/project-api';
import SearchResults from '../../SearchResults';
import KeywordsResults from '../../KeywordsResults';
import ProjectPanel from '../../ProjectPanel';
import styles from './style.module.less';
export const Row = (_a) => {
    var { listedProject, search = null, showKeywords } = _a, props = __rest(_a, ["listedProject", "search", "showKeywords"]);
    if (listedProject === undefined) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return _jsx("tr", Object.assign({}, props));
    }
    if (search !== null && isSearchedProject(listedProject)) {
        const hasSomeHighlight = listedProject.transcriptionHighlight.length > 0
            || listedProject.speakerHighlight.length > 0
            || listedProject.notesHighlight.length > 0;
        return (_jsxs(_Fragment, { children: [_jsx("tr", Object.assign({ className: clsx({ [styles.projectResults]: hasSomeHighlight }, 'ant-table-row'), 
                    // This is provisional solution as the class is not being attributed,
                    // it needs to be examined why:
                    // https://trello.com/c/wgdbDpcq/1944
                    id: hasSomeHighlight ? 'proj-results' : '' }, props)), listedProject.keywordsHighlight.length !== 0 && showKeywords ? (_jsx("tr", { children: _jsx(KeywordsResults, { keywordHighlight: listedProject.keywordsHighlight, projectId: listedProject.id }) })) : null, _jsx("tr", { className: clsx({ [styles.searchRow]: !hasSomeHighlight }), children: _jsx(SearchResults, { searchedProject: listedProject }) })] }));
    }
    return listedProject.keywordsHighlight.length !== 0 && showKeywords ? (_jsxs(_Fragment, { children: [_jsx("tr", Object.assign({}, props, { id: "proj-results" })), _jsx("tr", { children: _jsx(KeywordsResults, { keywordHighlight: listedProject.keywordsHighlight, projectId: listedProject.id }) })] })) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    _jsx("tr", Object.assign({}, props)));
};
export const expandedRowRender = (listedProject, fetchProjects, fetchTags) => (_jsx(ProjectPanel, { project: listedProject, onUpdateProjects: () => fetchProjects(false), onUpdateTags: () => fetchTags() }));
